module.exports = __webpack_public_path__ + "img/phone-left.7d52af7e.png";